import * as React from 'react';
import MaskedInput from 'react-text-mask';
import * as vars from '../../consts/variables';
import { scrollElementIntoView } from '../../helpers/scroll';
import { TestSelector } from '../../helpers/TestSelector';

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        margin: '0 15px 20px',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        marginTop: 0,
    },
    input: {
        width: '100%',
        padding: 10,
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        appearance: 'none',
        height: 40,
        fontSize: 16,
        opacity: 1,
        border: `1px solid ${vars.gray}`,
        color: `${vars.black}`,
        background: 'transparent',
    },
    inputText: {
        opacity: 1,
    },
    inputDate: {
        top: -40,
        position: 'relative',
        opacity: 0,
    },
    inputWrapper: {
        height: 40,
    },
};

interface IProps {
    value: string;
    placeholder: string;
    isError?: boolean;
    type?: string;
    onChange(event: React.ChangeEvent<any>): void;
    wrapperStyle?: any;
    inputStyle?: React.CSSProperties;
    isFirstInvalidFormField?: boolean;
    testSelectorName?: string;
    mask?: any;
    maskPlaceholder?: string;
}

interface IState {
    placeholder: string;
}

export class Input extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            placeholder: this.props.placeholder,
        };
    }

    inputRef = null;
    getInputRef = (ref) => (this.inputRef = ref);

    handleFocus = () => {
        this.setState({ placeholder: this.props.maskPlaceholder || this.props.placeholder });
    };

    handleBlur = () => {
        this.setState({ placeholder: this.props.placeholder });
    };

    shouldComponentUpdate(nextProps: IProps, nextState: IState) {
        const {
            value,
            placeholder,
            isError,
            type,
            wrapperStyle,
            isFirstInvalidFormField,
            mask,
            maskPlaceholder,
        } = this.props;
        return (
            isError !== nextProps.isError ||
            isFirstInvalidFormField !== nextProps.isFirstInvalidFormField ||
            value !== nextProps.value ||
            placeholder !== nextState.placeholder ||
            type !== nextProps.type ||
            wrapperStyle !== nextProps.wrapperStyle ||
            mask !== nextProps.mask ||
            this.state.placeholder !== nextState.placeholder ||
            maskPlaceholder !== nextProps.maskPlaceholder
        );
    }

    componentDidUpdate() {
        if (this.props.isFirstInvalidFormField && this.props.isError) {
            scrollElementIntoView(this.inputRef);
        }
    }

    render() {
        const {
            placeholder,
            isError,
            type,
            value,
            onChange,
            wrapperStyle,
            mask,
            maskPlaceholder,
            inputStyle,
            testSelectorName,
        } = this.props;
        const inputStyleDefault = isError
            ? { ...styles.input, border: `1px solid ${vars.pink}` }
            : styles.input;
        const inputType = type || 'text';

        return (
            <div ref={this.getInputRef} style={{ ...styles.wrapper, ...wrapperStyle }}>
                {mask ? (
                    <MaskedInput
                        type={inputType}
                        style={inputStyleDefault}
                        value={value}
                        placeholder={this.state.placeholder}
                        onChange={onChange}
                        onFocus={maskPlaceholder ? this.handleFocus : null}
                        onBlur={maskPlaceholder ? this.handleBlur : null}
                        mask={mask}
                        {...TestSelector.getSelector(testSelectorName)}
                    />
                ) : (
                    <input
                        type={inputType}
                        style={{ ...inputStyleDefault, ...inputStyle }}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        {...TestSelector.getSelector(testSelectorName)}
                    />
                )}
            </div>
        );
    }
}
